/************** suburbs.js **************** */

// imported into main.js
// loads suburb list from json File which is used to populate
// an 'auto complete' suburb selection field


import Suburbs from './suburbs.json';

let suburbData = Suburbs;

//declare suburb input field
//and hidden warning when suburb is not found in the list
const currSuburbInput = document.querySelector('#currSuburb'),
  unrecSuburb = document.querySelector('#unrecognised');

  // check if user is logged in when they enter the suburb field
  currSuburbInput.addEventListener('focus', () => {
    if (!window.loginCheck) {
      window.doLogin();
      currSuburbInput.blur();
    }
  });

  // listen for user input on the suburb field
  currSuburbInput.addEventListener('input', () => {
    // declare div that will hold the list suburbs that match input
    const acSuburb = document.querySelector("#sub-autocomplete");

    let term = currSuburbInput.value,  // get user input
      LCTerm = term.toLowerCase(), // set input to lower case
      suburbSet;

      //remove any existing list and ensure unrecognised suburb warning is not displayed
      if (document.querySelector('#suburbList')) {
        acSuburb.removeChild(document.querySelector('#suburbList'));
      }
      unrecSuburb.style.display = "none";

    // when we get three letters - start displaying matching suburbs
    if (term.length >= 3) {
      suburbSet = suburbData.filter(function (item) {
        if (item.suburb_name.toLowerCase() !== null && item.suburb_name.toLowerCase() !== '') {
          let LCdata = item.suburb_name.toLowerCase();
          //return LCdata.indexOf(LCTerm) !== -1; // returns if somewhere in string
          return LCdata.indexOf(LCTerm) === 0; // returns when matches start of string
        }
      });

      //create div to hold list of matching suburbs
      let suburbList = document.createElement('div');

      suburbList.id = 'suburbList';
      if (suburbSet.length < 1) { // if no matching suburbs - display warning
        unrecSuburb.style.display = "block";
      } else {  // display list of matching suburbs
        suburbSet.forEach(suburb => {
          let newSuburb = document.createElement('div');
          newSuburb.classList.add('li-suburb');
          newSuburb.dataset.sid = suburb.suburb_id;
          newSuburb.innerText = `${suburb.suburb_name}, ${suburb.ta}`;
          suburbList.appendChild(newSuburb);

          // when user clicks on the desired suburb
          // copy data into the sububr field
          newSuburb.addEventListener('click', () => {
            currSuburbInput.value = newSuburb.innerText;
            currSuburbInput.dataset.sid = newSuburb.dataset.sid;
            currSuburbInput.style.color = "rgb(0, 0, 0)";

            /********** SEND SELECTED SUBURB TO ADOBE ANALYTICS *** */
            // let digitalData = {};

            window.digitalData = {
              clickTracking: {
                sweetSpotSuburb: newSuburb.dataset.sid
              }
            }

            _satellite.track('sweetSpotSuburb');
            //console.log(window.digitalData);
            /****************************************************** */

            // remove list of matching suburbs from display
            acSuburb.removeChild(document.querySelector('#suburbList'));
          });
        });
        acSuburb.appendChild(suburbList);
      }
    }
  });
